module.exports = __webpack_public_path__ + "static/media/btn-left-arrow.86e32c07.svg";